import {
  CurrentUserDocument,
  CurrentUserQuery,
  CurrentUserQueryVariables,
} from '~/graphql/current-user'
import { useApolloClient } from '@apollo/client'

export const useGetCurrentUser = () => {
  const client = useApolloClient()

  const getCurrentUser = async () => {
    const { data } = await client.query<
      CurrentUserQuery,
      CurrentUserQueryVariables
    >({
      query: CurrentUserDocument,
      variables: {},
    })

    return data?.currentUser
  }

  return getCurrentUser
}
